import React from 'react';
import { Button } from './ui/button';
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from './ui/breadcrumb';
import { ChevronLeft } from 'lucide-react';

function Header({ breadcrumbs = [], onNavigate }) {
  // Get the back action from the last clickable breadcrumb
  const backAction = breadcrumbs.length > 1 ? breadcrumbs[breadcrumbs.length - 2]?.onClick : breadcrumbs[0]?.onClick;
  const showBackButton = breadcrumbs.length > 1 && backAction;

  return (
    <header className="bg-neutral-50 border-b border-neutral-200 px-8 py-4 shadow-sm">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-6">
          {showBackButton && (
            <Button
              variant="outline"
              size="sm"
              onClick={backAction}
              className="gap-2"
            >
              <ChevronLeft className="h-4 w-4" />
              Back
            </Button>
          )}
          <Breadcrumb className="flex-1">
            <BreadcrumbList>
              {breadcrumbs.map((crumb, index) => (
                <React.Fragment key={index}>
                  {index > 0 && <BreadcrumbSeparator />}
                  <BreadcrumbItem>
                    {crumb.onClick ? (
                      <BreadcrumbLink onClick={crumb.onClick}>
                        {crumb.label}
                      </BreadcrumbLink>
                    ) : (
                      <BreadcrumbPage>{crumb.label}</BreadcrumbPage>
                    )}
                  </BreadcrumbItem>
                </React.Fragment>
              ))}
            </BreadcrumbList>
          </Breadcrumb>
        </div>
      </div>
    </header>
  );
}

export default Header;
